import { Loader } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import logoSrc from "@/assets/favicon_io/android-chrome-192x192.png";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app/dashboard" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-svh w-full items-center justify-center bg-background">
        <Loader />
      </div>
    );
  }
  return (
    <div className="flex min-h-svh w-full items-center justify-center bg-background px-4">
      <div className="mx-auto flex w-full max-w-md flex-col justify-center gap-8 py-8 sm:py-10">
        {/* PARTZYNC: Logo + Safe Zone (ระยะห่างรอบโลโก้ ≥ ความสูงตัว P) */}
        <header className="flex flex-col items-center gap-4">
          <div className="flex items-center justify-center p-4">
            <img
              src={logoSrc}
              alt="PARTZYNC"
              width={80}
              height={80}
              className="h-20 w-20 object-contain"
            />
          </div>
          <h1 className="text-center font-bold font-heading text-foreground text-xl tracking-tight sm:text-2xl">
            PARTZYNC Admin
          </h1>
        </header>
        <Outlet />
      </div>
    </div>
  );
}
